import  "./Loader.css"

const loader =() => {
    return(
        <div class="loader">Loading...</div>
    );
};
export default loader;